var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "card" }, [
      _c("div", { staticClass: "card-header" }, [
        _c("div", { staticClass: "flex justify-content-between" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("pulse-loader", {
                staticClass: "text-center",
                attrs: {
                  loading: _vm.loading.parser,
                  color: _vm.$constants.LOADING_COLOR,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "text-right" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-default",
                attrs: { type: "button" },
                on: { click: _vm.getParserData },
              },
              [_vm._v("Обновить")]
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "card-body" },
        [
          [
            _c("table", { staticClass: "table table-sm table-hover mt-0" }, [
              _vm._m(1),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(_vm.parserData, function (p, alias, i) {
                  return _c("tr", [
                    _c("td", [_vm._v(_vm._s(_vm.parserTypes[alias]))]),
                    _vm._v(" "),
                    _c("td", [
                      _c(
                        "span",
                        {
                          class: `badge ${_vm.parserStatuses[p.status]?.class}`,
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.parserStatuses[p.status]
                                  ? _vm.parserStatuses[p.status].title
                                  : ""
                              ) +
                              "\n              "
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        _vm._s(p.domain && p.domain != "0" ? p.domain : null)
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(p.attempts))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(p.total_links))]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        _vm._s(
                          p.created_at ? _vm.printDate(p.created_at) : "н/д"
                        )
                      ),
                    ]),
                  ])
                }),
                0
              ),
            ]),
          ],
        ],
        2
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card" }, [
      _vm._m(2),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "card-body" },
        [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col col-4" }, [
              _c("label", [_vm._v("Port")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.proxyForm.port,
                    expression: "proxyForm.port",
                  },
                ],
                staticClass: "form-control",
                domProps: { value: _vm.proxyForm.port },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.proxyForm, "port", $event.target.value)
                  },
                },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col col-4" }, [
              _c("label", [_vm._v("Login")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.proxyForm.login,
                    expression: "proxyForm.login",
                  },
                ],
                staticClass: "form-control",
                domProps: { value: _vm.proxyForm.login },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.proxyForm, "login", $event.target.value)
                  },
                },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col col-4" }, [
              _c("label", [_vm._v("Password")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.proxyForm.password,
                    expression: "proxyForm.password",
                  },
                ],
                staticClass: "form-control",
                domProps: { value: _vm.proxyForm.password },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.proxyForm, "password", $event.target.value)
                  },
                },
              }),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "row mt-2",
              staticStyle: { "align-items": "center" },
            },
            [
              _c("div", { staticClass: "col col-12" }, [
                _c("label", [_vm._v("IP")]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "d-flex", staticStyle: { gap: "10px" } },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.proxyForm.ip,
                          expression: "proxyForm.ip",
                        },
                      ],
                      staticClass: "form-control",
                      staticStyle: { "max-width": "460px" },
                      domProps: { value: _vm.proxyForm.ip },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.proxyForm, "ip", $event.target.value)
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-outline-primary",
                        on: {
                          click: function ($event) {
                            return _vm.addNewProxy()
                          },
                        },
                      },
                      [_vm._v("Добавить")]
                    ),
                  ]
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _vm._l(_vm.proxyForm.items, function (newItem, index) {
            return _c(
              "div",
              { staticClass: "row mt-2", staticStyle: { gap: "10px" } },
              [
                _c("div", { staticClass: "col col-12" }, [
                  _c("small", [
                    _vm._v(
                      _vm._s(newItem.login) +
                        ":" +
                        _vm._s(newItem.password) +
                        " " +
                        _vm._s(newItem.port)
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "d-flex",
                      staticStyle: { gap: "10px", "align-items": "center" },
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: newItem.value,
                            expression: "newItem.value",
                          },
                        ],
                        key: index,
                        staticClass: "form-control",
                        staticStyle: { "max-width": "460px" },
                        domProps: { value: newItem.value },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(newItem, "value", $event.target.value)
                          },
                        },
                      }),
                      _vm._v(" "),
                      !newItem.is_invalid
                        ? _c("span", [_vm._v("OK")])
                        : _vm._e(),
                      _vm._v(" "),
                      newItem.is_invalid && newItem.is_invalid !== -1
                        ? _c("span", { staticStyle: { color: "red" } }, [
                            _vm._v("ОШИБКА"),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-outline-secondary",
                          on: {
                            click: function ($event) {
                              return _vm.testNewProxy(index)
                            },
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.loading.item === "new" + index
                                ? "Выполняется тест..."
                                : "Проверить"
                            )
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-outline-danger",
                          on: {
                            click: function ($event) {
                              return _vm.rmNewProxy(index)
                            },
                          },
                        },
                        [_vm._v("Удалить")]
                      ),
                      _vm._v(" "),
                      !newItem.store
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn-xs btn-outline-success",
                              on: {
                                click: function ($event) {
                                  return _vm.storeNewProxy(index)
                                },
                              },
                            },
                            [_vm._v("Сохранить в БД")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      newItem.store
                        ? _c("span", { staticClass: "badge badge-success" }, [
                            _vm._v("Сохранено в БД"),
                          ])
                        : _vm._e(),
                    ]
                  ),
                ]),
              ]
            )
          }),
          _vm._v(" "),
          _vm.proxyForm.items.length
            ? _c(
                "button",
                {
                  staticClass: "btn btn-outline-secondary mt-2",
                  on: {
                    click: function ($event) {
                      return _vm.testNewProxy("all")
                    },
                  },
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.loading.item === "newAll"
                        ? "Выполняется тест..."
                        : "Проверить все"
                    )
                  ),
                ]
              )
            : _vm._e(),
        ],
        2
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card" }, [
      _vm._m(3),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "card-body" },
        [
          _c("pulse-loader", {
            staticClass: "text-center",
            attrs: {
              loading: _vm.loading.proxy,
              color: _vm.$constants.LOADING_COLOR,
            },
          }),
          _vm._v(" "),
          !_vm.loading.proxy && _vm.proxyData
            ? [
                _c(
                  "table",
                  { staticClass: "table table-hover table-sm mt-0" },
                  [
                    _c("thead", [
                      _c("tr", [
                        _c("th"),
                        _vm._v(" "),
                        _c("th", [_vm._v("IP")]),
                        _vm._v(" "),
                        _c("th", [
                          _c("label", { staticClass: "alt-source-chb" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.altSource,
                                  expression: "altSource",
                                },
                              ],
                              attrs: { type: "checkbox" },
                              domProps: {
                                checked: Array.isArray(_vm.altSource)
                                  ? _vm._i(_vm.altSource, null) > -1
                                  : _vm.altSource,
                              },
                              on: {
                                change: function ($event) {
                                  var $$a = _vm.altSource,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.altSource = $$a.concat([$$v]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.altSource = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.altSource = $$c
                                  }
                                },
                              },
                            }),
                            _c("small", [
                              _vm._v("Альтернативный ресурс (новости rbc.ru)"),
                            ]),
                          ]),
                          _c("br"),
                          _vm._v(
                            "\n              тест валидности\n              "
                          ),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-xs btn-outline-secondary",
                              staticStyle: { "margin-left": "6px" },
                              on: {
                                click: function ($event) {
                                  return _vm.testAll()
                                },
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.loading.item === "all"
                                    ? "Выполняется тест..."
                                    : "Проверить все"
                                )
                              ),
                              _vm.loading.item === "all"
                                ? _c(
                                    "span",
                                    { staticClass: "badge badge-secondary" },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.stateCount) +
                                          " / " +
                                          _vm._s(_vm.proxyData.length)
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("th", { staticStyle: { "text-align": "right" } }, [
                          _vm._v("ошибки (повторные)"),
                        ]),
                        _vm._v(" "),
                        _c("th", { staticStyle: { "text-align": "right" } }, [
                          _vm._v("добавлен"),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.proxyData, function (r, i) {
                        return _c(
                          "tr",
                          {
                            class: {
                              "has-error": r.errors >= 3 && !r.is_invalid,
                              invalid: r.is_invalid,
                              handled: _vm.handledIps.includes(r.ip),
                            },
                          },
                          [
                            _c(
                              "td",
                              { staticStyle: { "text-align": "right" } },
                              [_vm._v(_vm._s(i + 1))]
                            ),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(r.ip))]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                "\n              " +
                                  _vm._s(r.is_invalid ? "ОШИБКА" : "OK") +
                                  "\n              "
                              ),
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-xs btn-outline-secondary",
                                  staticStyle: { "margin-left": "6px" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.testProxy(r)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.loading.item === r.id
                                        ? "Выполняется тест..."
                                        : "Проверить"
                                    )
                                  ),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "td",
                              { staticStyle: { "text-align": "right" } },
                              [_vm._v(_vm._s(r.errors))]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              { staticStyle: { "text-align": "right" } },
                              [
                                _vm._v(
                                  _vm._s(
                                    r.created_at
                                      ? _vm.printDate(
                                          r.created_at,
                                          "DD.MM.YYYY"
                                        )
                                      : "н/д"
                                  )
                                ),
                              ]
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                  ]
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [_c("h5", [_vm._v("РКН парсер")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("тип")]),
        _vm._v(" "),
        _c("th", [_vm._v("статус")]),
        _vm._v(" "),
        _c("th", [_vm._v("домен")]),
        _vm._v(" "),
        _c("th", [_vm._v("запросов")]),
        _vm._v(" "),
        _c("th", [_vm._v("ресурсов")]),
        _vm._v(" "),
        _c("th", [_vm._v("дата")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h5", [_vm._v("Новый прокси")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h5", [_vm._v("Список прокси")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }